import React, { useState, useEffect } from "react";
import HomeTemplate from "../components/templates/HomeTemplate.jsx";
import logoImage from "../assets/doberan_name_logo.png";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://hp.api.doberan.jp';

const aboutTexts = [
  "ゲームも雑談もゆったりやってくよ！",
  "I'm a casual gamer who enjoys anything!"
];

const aboutDoberanItems = [
  "メインでやるゲーム：VALORANT",
  "性格：温厚、ゆったり",
  "固定配信：毎週木曜日の24時から",
  "ひとこと：趣味でゆったりやってるのでよかったら来てね～"
];

const navbarLinks = [
  { href: "#logo", label: "TOP" },
  { href: "#about-doberan", label: "ABOUT US" },
  { href: "#live", label: "Live Now" },
  // { href: "#clips", label: "Watch a Clip" } // Watch a Clipセクションを非表示にするためコメントアウト
  { href: "#footer", label: "SNS" }, // フッターへのリンクを追加
];

const socialLinks = [
  { href: "https://x.com/doberan_games", icon: "", label: "X" },
  { href: "https://www.instagram.com/doberan.movie/", icon: "", label: "instagram" },
  { href: "https://www.youtube.com/@%E3%81%A9%E3%81%B9%E3%82%89%E3%82%93%E3%83%81%E3%83%A3%E3%83%B3%E3%83%8D%E3%83%AB", icon: "", label: "YouTube" },
  { href: "https://www.twitch.tv/doberan_games", icon: "", label: "Twitch" },
];

const copyrightText = '© 2025 doberan';

const HomePage = () => {
  const [latestTwitchClips, setLatestTwitchClips] = useState([]);
  const [popularTwitchClips, setPopularTwitchClips] = useState([]);

  useEffect(() => {
    // react-snapによるプリレンダリング中はAPIフェッチをスキップ
    const isPrerendering = navigator.userAgent === 'ReactSnap';
    if (isPrerendering) {
      return;
    }

    const fetchClips = async () => {
      try {
        // Twitchの配信情報とクリップをまとめて取得
        const twitchResponse = await fetch(`${API_BASE_URL}/twitch`);
        if (!twitchResponse.ok) {
          throw new Error('Twitch情報の取得に失敗しました');
        }
        const twitchData = await twitchResponse.json();
        console.log("Twitchデータ:", twitchData);
        setLatestTwitchClips(twitchData.clips.latest);
        setPopularTwitchClips(twitchData.clips.popular);

      } catch (error) {
        console.error("クリップの取得中にエラーが発生しました:", error);
        // エラーハンドリング：必要に応じてUIにメッセージを表示する
      }
    };

    fetchClips();
  }, []);

  return (
    <HomeTemplate
      navbarLinks={navbarLinks}
      logoSrc={logoImage}
      logoAlt="doberan logo"
      aboutTexts={aboutTexts}
      aboutDoberanItems={aboutDoberanItems}
      latestTwitchClips={latestTwitchClips}
      popularTwitchClips={popularTwitchClips}
      socialLinks={socialLinks}
      copyrightText={copyrightText}
    />
  );
};

export default HomePage; 